import React from "react";


import {
    InformativeCardComponent
} from "@Components/Elements";


import iconMessage from "@Icons/SVG/icon-message.svg";


import "./index.scss";


export type FaqQuestionType = {
    questionText: string;
    answerText: string;
};


type FaqQuestionComponentProps = {
    Question: FaqQuestionType;
};


export const FaqQuestionComponent:React.FC<FaqQuestionComponentProps> = ({
    Question
}) => {

    if (!Question) {
        return null;
    }

    const { questionText, answerText } = Question;

    const answerTextElement = `<span>${answerText}</span>`;

    return (
        <InformativeCardComponent
            cardDecoration={{ decorationType: 'icon', decorationSource: iconMessage }}
            cardTitle={questionText}
            cardDescription={answerTextElement}
            xl={6}
        />
    );

};


export default FaqQuestionComponent;
